// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3OSvA","content":"GlobalSearch_content__3HzGl"};